const initialState = {
    user: {},
    updating: false,
    updated: false,
    error: null,

    history: [],
    page: 1,
    updatingHistory: false,
    updatedHistory: false,
    errorHistory: null,

    users: [],
    updatingUsers: false,
    updatedUsers: false,
    errorUsers: null
}

export function userReducer(state = initialState, action) {

    switch (action.type) {

        case "FETCH_USER":
        case "UPDATE_USER": {
            return { ...state, updating: true, updated: false, error: null }
        }

        case "FETCH_USER_REJECTED":
        case "UPDATE_USER_REJECTED": {
            return { ...state, updating: false, error: action.payload }
        }

        case "FETCH_USER_FULFILLED":
            if (!action.payload.data.designerPhone)
                action.payload.data.designerPhone = action.payload.data.officePhone

        case "UPDATE_USER_FULFILLED": {
            return { ...state, updating: false, updated: true, user: action.payload.data }
        }

        case "USER_ERROR": {
            return { ...state, error: null }
        }

        case "FETCH_USER_HISTORY": {
            return { ...state, page: action.payload.data.page, updatingHistory: true, updatedHistory: false, errorHistory: null }
        }

        case "FETCH_USER_HISTORY_REJECTED": {
            return { ...state, updatingHistory: false, errorHistory: action.payload }
        }

        case "FETCH_USER_HISTORY_FULFILLED": {
            var history = Object.assign({}, state.history)

            history.totalRecords = action.payload.data.totalRecords

            if (state.page == 1)
                history.userChangeHistoryRecords = []

            action.payload.data.userChangeHistoryRecords.forEach((hist) => {
                history.userChangeHistoryRecords.push(hist)
            })

            history.userChangeHistoryRecords.sort(function (a, b) {
                var d1 = new Date(a.changeDate)
                var d2 = new Date(b.changeDate)

                if (d1 > d2)
                    return -1
                else if (d1 < d2)
                    return 1
                else
                    return 0
            })

            return { ...state, updatingHistory: false, updatedHistory: true, history: history }
        }

        case "USER_HISTORY_ERROR": {
            return { ...state, errorHistory: null }
        }

        case "FETCH_USER_USERS": {
            return { ...state, updatingUsers: true, updatedUsers: false, errorUsers: null }
        }

        case "FETCH_USER_USERS_REJECTED": {
            return { ...state, updatingUsers: false, errorUsers: action.payload }
        }

        case "FETCH_USER_USERS_FULFILLED": {
            return { ...state, updatingUsers: false, updatedUsers: true, users: action.payload.data }
        }

        case "USER_USERS_ERROR": {
            return { ...state, errorUsers: null }
        }

        default:
            return state
    }
}